import { streemLogger } from '../util/streem_logger';
class PromiseWrapper {
    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    get resolve() {
        return this._resolve;
    }
    get reject() {
        return this._reject;
    }
}
// This observer handles multiple scenarios for the chime room:
//   - waiting for the meeting to start
//   - waiting for the meeting to stop
//   - logging out error conditions
//
// Note: We might want to expose some errors as Observables so they
//       can be handled in a more reactive way in the ChimeRoom.
export class ChimeMeetingObserver {
    constructor(onMeetingReconnected) {
        this.onMeetingReconnected = onMeetingReconnected;
        this.logger = streemLogger.extend('sdk-chime-video:ChimeMeetingObserver');
        this.meetingStartPromiseWrapper = new PromiseWrapper();
        this.meetingStopPromiseWrapper = new PromiseWrapper();
    }
    // this allows for the chime_room to wait for the meeting to fully start
    waitForMeetingStart() {
        return this.meetingStartPromiseWrapper.promise;
    }
    waitForMeetingStop() {
        return this.meetingStopPromiseWrapper.promise;
    }
    eventDidReceive(name, attributes) {
        const attributesWithoutHistory = { ...attributes };
        // meeting history can be big, so do not log it
        delete attributesWithoutHistory.meetingHistory;
        switch (name) {
            case 'meetingStartSucceeded':
                this.meetingStartPromiseWrapper.resolve(attributes);
                this.logger.info(`ChimeRoom: meeting successfully started event=${name}`, attributesWithoutHistory);
                break;
            case 'meetingStartFailed':
                this.meetingStartPromiseWrapper.reject(attributes);
                this.logger.error(`Chime meeting start failed errorMessage: ${attributes.meetingErrorMessage ?? 'unknown error'} event=${name}`, attributesWithoutHistory);
                break;
            case 'meetingEnded':
                this.meetingStopPromiseWrapper.resolve(attributes);
                this.logger.info(`Chime meeting successfully ended, event=${name}`, attributesWithoutHistory);
                break;
            case 'meetingFailed':
                this.logger.error(`Chime meeting failed errorMessage: ${attributes.meetingErrorMessage ?? 'unknown error'} event=${name}`, attributesWithoutHistory);
                break;
            case 'deviceLabelTriggerFailed':
            case 'audioInputFailed':
            case 'videoInputFailed':
            case 'sendingAudioFailed':
            case 'receivingAudioDropped':
                this.logger.warn(`Unexpected event during Chime room: event=${name}`, attributesWithoutHistory);
                break;
            case 'signalingDropped':
                // this may not signify a problem as it happens when the meeting ends
                //    (and is called before the meetingEnded event)
                this.logger.info(`Chime meeting signaling dropped: event=${name}`, attributesWithoutHistory);
                break;
            case 'meetingReconnected':
                this.logger.info(`Chime meeting reconnected: event=${name}`, attributesWithoutHistory);
                this.onMeetingReconnected();
                break;
            case 'sendingAudioRecovered':
                this.logger.info(`Chime meeting audio recovered, event=${name}`, attributesWithoutHistory);
                break;
            default:
                // log at debug level to avoid spamming logs (and scribe)
                this.logger.debug(`Chime meeting event: event=${name}`, attributesWithoutHistory);
                break;
        }
    }
}
//# sourceMappingURL=chime_meeting_observer.js.map